import type { WallpaperOption, CursorOption } from './types';

export const WALLPAPERS: WallpaperOption[] = [
  // Tahoe / Liquid Glass style
  {
    id: 'tahoe-blue-glass',
    name: 'Tahoe Blue Glass',
    url: '/wallpapers/tahoe-blue-glass.jpg',
  },
  // macOS Sonoma style
  {
    id: 'sonoma-light',
    name: 'Sonoma Light',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'sonoma-dark',
    name: 'Sonoma Dark',
    url: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2560&auto=format&fit=crop',
  },
  // macOS Ventura style
  {
    id: 'ventura',
    name: 'Ventura',
    url: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?q=80&w=2560&auto=format&fit=crop',
  },
  // macOS Monterey style
  {
    id: 'monterey',
    name: 'Monterey',
    url: 'https://images.unsplash.com/photo-1507400492013-162706c8c05e?q=80&w=2560&auto=format&fit=crop',
  },
  // macOS Big Sur style
  {
    id: 'big-sur',
    name: 'Big Sur',
    url: 'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?q=80&w=2560&auto=format&fit=crop',
  },
  // Windows 11 Bloom style
  {
    id: 'bloom-light',
    name: 'Bloom Light',
    url: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'bloom-dark',
    name: 'Bloom Dark',
    url: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?q=80&w=2560&auto=format&fit=crop',
  },
  // Windows Flow style
  {
    id: 'flow',
    name: 'Flow',
    url: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop',
  },
  // Windows Glow style
  {
    id: 'glow',
    name: 'Glow',
    url: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?q=80&w=2560&auto=format&fit=crop',
  },
  // Aurora / Northern Lights
  {
    id: 'aurora',
    name: 'Aurora',
    url: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?q=80&w=2560&auto=format&fit=crop',
  },
  // Abstract gradients
  {
    id: 'gradient-purple',
    name: 'Purple Haze',
    url: 'https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'gradient-blue',
    name: 'Ocean Blue',
    url: 'https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?q=80&w=2560&auto=format&fit=crop',
  },
  // Nature
  {
    id: 'mountains',
    name: 'Mountains',
    url: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'desert',
    name: 'Desert Dunes',
    url: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'forest',
    name: 'Misty Forest',
    url: 'https://images.unsplash.com/photo-1440342359743-84fcb8c21f21?q=80&w=2560&auto=format&fit=crop',
  },
  // Minimal
  {
    id: 'minimal-light',
    name: 'Minimal Light',
    url: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?q=80&w=2560&auto=format&fit=crop',
  },
  {
    id: 'minimal-dark',
    name: 'Minimal Dark',
    url: 'https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2560&auto=format&fit=crop',
  },
  // Solid color option
  {
    id: 'none',
    name: 'Solid Color',
    url: '',
  },
];

export const CURSOR_OPTIONS: CursorOption[] = [
  { id: 'default', name: 'Default', cursor: 'default', icon: '🖱️' },
  { id: 'pointer', name: 'Pointer', cursor: 'pointer', icon: '👆' },
  { id: 'crosshair', name: 'Crosshair', cursor: 'crosshair', icon: '➕' },
];
